export default __webpack_public_path__ + "static/media/icecream-cupcake.d84899ac.png";